<template>
  <base-modal
    id="NotificationEditModal"
    :show="show"
    size="modal-md"
    :show-close-button="false"
  >
    <div class="custom-title">
      <span class="title-text">
        Create new post
      </span>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closed()"
      >
        <base-icon
          style="height:20px; color: black; "
          icon="cancel"
        />
      </button>
    </div>
    <div class="underline" />
    <div class="notification-edit-modal">
      <vue-editor
        :id="'notificationEditor-'+uniqid"
        ref="editor"
        v-model="content"
        :editor-options="editorSettings"
        @selection-change="selectionChange"
        @editor-change="onEditorChange"
        @blur="isFocused = false"
        @focus="isFocused = true"
        @ready="onEditorReady"
      />
      <div class="toolbar__container">
        <div
          id="notification-editor-toolbar"
          class="d-flex align-items-center"
        >
          <span class="ql-formats">
            <button
              v-if="attachments && useFeature('upload_file')"
              type="button"
              class="ql-attach"
              @click="triggerAddAttachment"
            >
              <editor-attach-file
                v-show="false"
                v-if="useFeature('upload_file')"
                ref="attachFile"
                :show="addAttachment"
                :clear="clearAttachment"
                :value="attachmentName"
                :multiple="false"
                accept="application/pdf, image/png, image/jpeg, image/gif"
                @input="$emit('upload-attachment', $event)"
                @upload-started="onUploadStarted"
                @progress="attachmentProgress = $event"
                @uploaded="onUploadSuccess"
                @cleaned="onUploadCleaned"
                @error="onUploadFailure"
              />
            </button>
            <button
              type="button"
              class="ql-link"
            />
            <button
              type="button"
              class="ql-bold"
            />
            <button
              type="button"
              class="ql-italic"
            />
            <button
              v-if="emojis"
              type="button"
              class="ql-emoji"
              @click="toggleEmojiDialog"
            />
            <!--  <button type="button"
              class="ql-underline" /> -->
          </span>
          <span class="ql-formats mr-0 ml-auto post-button-text">
            <base-text
              size="md"
              class="text-right"
            >
              <span
                class="cursor-pointer pl-2"
                @click="postAndClean"
              >
                Post
              </span>
            </base-text>
          </span>
          <div
            v-show="!dialogHidden"
            class="picker"
          >
            <v-emoji-picker
              :emoji-size="27"
              :emoji-with-border="false"
              :emojis-by-row="10"
              @select="onSelectEmoji"
            />
          </div>
        </div>
      </div>
    </div>
    <attachments
      class="pt-4"
      :files="attachedFiles"
      @clear="triggerClearAttachment"
    />
  </base-modal>
</template>
<script>
import NotificationEditor from './Notifications/NotificationEditor';

export default {
  name: 'NotificationEditModal',
  extends: NotificationEditor,
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    postAndClean() {
      this.post();
      this.content = '';
      this.onUploadCleaned();
    },
    closed() {
      this.content = '';
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>

.post-button-text {
    margin-top: 10px;
    font-family: 'SilkaLight';
    font-size: 14px;
    color: $black;
}
.title-text {
font-family:  $font-family-serif;
font-style: normal;
font-weight: lighter;
font-size: 20px;
line-height: 24px;
/* identical to box height, or 120% */

color: #333333;
}
.custom-title {
    margin-bottom: 20px;
    margin-top: 8px;
    width: 400px;
}
.underline {
    margin-bottom: 32px;
    width: 400px;
    height: 1px;
    background: #ccc;
}
  .notification-edit-modal {
    padding: 0px 10px;
    border: solid 1px #ccc ;
    width: 400px;
    height: 138px;
  }
.ql-formats {
    height: 16px;
    margin: 0;
    background: transparent;
}

::v-deep .modal-content {
    padding: 24px 32px;
    width: 464px;
    border: 0px solid $black;
    border-radius: 0;
    margin-top: 60px;
}

::v-deep .modal-body {
    padding: 0;
}
::v-deep .ql-editor {
    padding: 16px;
  min-height: 90px !important;
  max-height: 90px;
  font-family: $font-family-sans-serif-light;
  font-size: 13px;
}
::v-deep .ql-editor strong{
  font-family: $font-family-sans-serif-medium;
  font-weight: normal;
}
#notification-editor-toolbar {
    padding: 16px;
    display: block;
}

::v-deep .toolbar__container {
    padding-top: 8px;

}
::v-deep button[class^="ql-"][type="button"]:not(.ql-addTag)  {
    height: 16px;
    width: 16px;
    margin-right: 16px;
    padding: 0px;
  &.ql-active {
    background-color: rgba(black, 0.1) !important;
    border-radius: 4px !important;
  }
}

::v-deep .ql-emoji {
  background-image: url("~@/assets/icons/emoji.svg") !important;

}
.picker {
  position: absolute;
  left: 0px;
  top: 58px;
}

</style>
